/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface SkillMapDataPayload {
    cmId: string;
    rootId: string;
}

export interface SkillMapRootDataResponse {
    applyFlg: string;
    divisionData: DivisionDataItem[];
    levelData: LevelDataItem[];
}

export interface DivisionDataItem {
    fieldTitle: string;
    displayOrder: number;
    cmId: string;
    fieldId: string;
    lang: string;
    isLeaf: boolean;
    fieldLevel: number;
    parentFieldId: string;
    countOfSubject: number;
    fieldId1: string;
    fieldId2: string;
    fieldId3: string;
}

export interface LevelDataItem {
    levelTitle: string;
    levelId: string;
    contents: string;
    targetType: number;
    cmId: string;
    cmcId: string;
    fieldId: string;
    lang: string;
    status: number;
    comment: string;
}

class SkillMapRootDataService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "skillMapRootData");
    }

    public async skillMapRootData(
        payload: SkillMapDataPayload,
        resolved: (response: SkillMapRootDataResponse) => void,
        rejected: (error: any) => void
    ) {
        await super.postJSON(
            payload,
            (json: any) => {
                const response = json as SkillMapRootDataResponse;
                resolved(response);
            },
            rejected
        );
    }
}

export default SkillMapRootDataService;
